import cn from 'classnames';

import { Remove } from '../index';

import css from './remove.css';

export const RemoveBtn: FC<{
    color?: 'white' | 'blue' | 'navy' | 'grey';
    className?: string;
    disabled?: boolean;
    onClick?: (e?: any) => void;
}> = ({ className, color = 'blue', disabled, onClick }) => (
    <Remove
        className={cn(
            css.remove,
            {
                [css.white]: color === 'white',
                [css.blue]: color === 'blue',
                [css.navy]: color === 'navy',
                [css.grey]: color === 'grey',
                [css.disabled]: disabled,
            },
            className,
        )}
        onClick={onClick}
    />
);
